export default function MessageSection() {
  return (
    <section className='px-4 pt-8 pb-6'>
      <div className='text-center'>
        <h1 className='text-base font-normal text-gray-12 leading-relaxed'>
          みてねに残した、
          <br />
          二度と戻れない大切な時間。
          <br />
          そのたくさんの思い出が、
          <br />
          フォトフレームに自動で届きます。
          <br />
          家族の日常に、そっとぬくもりを。
        </h1>
      </div>
    </section>
  )
}
